<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="850px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div v-loading="loading">
      <el-tabs
        v-model="selectedTab"
        tab-position="top"
      >
        <el-tab-pane
          label="Alapadatok"
          name="Alapadatok"
        >
          <basic-data-form
            ref="basicData"
            :partner="partner"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="$refs.basicData && $refs.basicData.basicData.is_customer"
          label="Vevőadatok"
          name="Vevőadatok"
        >
          <customer-details-form
            ref="customerData"
            :partner="partner"
          />
        </el-tab-pane>
        <el-tab-pane
          label="EDI"
          name="EDI"
        >
          <edi-data-form
            ref="ediData"
            :partner="partner"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Címek"
          name="Címek"
        >
          <addresses-form
            :addresses="partner.company.addresses"
            @change="onAddressChange"
            @add="onAddressAdd"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Számlaszámok"
          name="Számlaszámok"
        >
          <bank-accounts-form
            :accounts="partner.company.account_numbers"
            @change="onAccountChange"
            @add="onAccountAdd"
          />
        </el-tab-pane>
        <el-tab-pane
          label="Kapcsolattartók"
          name="Kapcsolattartók"
        >
          <contact-people-form
            :contact-people="partner.partner_contact_people"
            @change="onContactPersonChange"
            @add="onContactPersonAdd"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleClose">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import BasicDataForm from './forms/BasicData';
import CustomerDetailsForm from './forms/CustomerDetails';
import EdiDataForm from './forms/EdiData';
import AddressesForm from './forms/Addresses';
import BankAccountsForm from './forms/BankAccounts';
import ContactPeopleForm from './forms/contactPeople/ContactPeople';
import PricesForm from './forms/Prices';

export default {
  components: {
    BasicDataForm,
    CustomerDetailsForm,
    EdiDataForm,
    AddressesForm,
    BankAccountsForm,
    ContactPeopleForm,
    PricesForm
  },
  props: ['type', 'partnerId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      selectedTab: 'Alapadatok',
      partner: {
        receipt_comment: '',
        company: {
          addresses: [],
          account_numbers: [],
        },
        partner_contact_people: [],
        product_prices: []
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Mező megadása kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    title() {
      if (this.type === 'add') {
        return 'Új partner';
      } else if (this.type === 'update') {
        return 'Partner módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    await Promise.all([
      this.$store.dispatch('supplierCategory/fetchAll'),
      this.$store.dispatch('customerCategory/fetchAll'),
      this.$store.dispatch('paymentMethod/fetchAll'),
    ]);
    if (this.partnerId) {
      this.partner = await this.$store.dispatch('partner/fetch', this.partnerId);
    }
    this.loading = false;
  },
  methods: {
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/data/partners');
        })
        .catch(() => {
        });
    },
    onAddressChange(addresses) {
      this.partner.company.addresses = addresses;
    },
    onAddressAdd(address) {
      this.partner.company.addresses.push(address);
    },
    onAccountChange(accounts) {
      this.partner.company.account_numbers = accounts;
    },
    onAccountAdd(account) {
      this.partner.company.account_numbers.push(account);
    },
    onContactPersonChange(contactPeople) {
      this.partner.partner_contact_people = contactPeople;
    },
    onContactPersonAdd(contactPerson) {
      this.partner.partner_contact_people.push(contactPerson);
    },
    onPriceChange(prices) {
      this.partner.product_prices = prices;
    },
    onPriceAdd(price) {
      this.partner.product_prices.push(price);
    },
    async store() {
      this.$refs.basicData.$refs.basicDataForm.validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            const data = Object.assign({}, this.$refs['basicData'].basicData);
            data.company.addresses = this.partner.company.addresses;
            let hasBillingAddress = false;
            data.company.addresses.forEach(address => {
              if (address.pivot.type === 'billing') {
                hasBillingAddress = true;
              }
            });
            if (!hasBillingAddress) {
              this.$messageWrapper.warning('Számlázási cím megadása kötelező');
              this.selectedTab = 'Címek';
              this.buttonLoading = false;
              return;
            }
            data.company.account_numbers = this.partner.company.account_numbers;
            data.partner_contact_people = this.partner.partner_contact_people;
            data.product_prices = this.partner.product_prices;
            if (this.$refs['ediData']) {
              data.edi_order_send_active = this.$refs['ediData'].ediData.edi_order_send_active;
              data.edi_order_send_test = this.$refs['ediData'].ediData.edi_order_send_test;
              data.edi_order_receive_active = this.$refs['ediData'].ediData.edi_order_receive_active;
              data.edi_desadv_send_active = this.$refs['ediData'].ediData.edi_desadv_send_active;
              data.edi_desadv_send_test = this.$refs['ediData'].ediData.edi_desadv_send_test;
              data.iln = this.$refs['ediData'].ediData.iln;
            }
            if (this.$refs['customerData']) {
              data.company = Object.assign({}, data.company, this.$refs['customerData'].customerData);
              data.payment_methods = this.$refs['customerData'].customerData.payment_methods;
              data.is_order_id_required = this.$refs['customerData'].customerData.is_order_id_required;
            }
            if (this.type === 'add') {
              await this.$store.dispatch('partner/create', data);
            } else if (this.type === 'update') {
              await this.$store.dispatch('partner/update', data);
            }
            this.$store.dispatch('partner/fetchAll');
            this.buttonLoading = false;
            this.$router.replace('/data/partners');
          } catch (e) {
            console.log(e);
          }
          this.buttonLoading = false;
        } else {
          this.selectedTab = 'Alapadatok';
        }
      });
    }
  },
};
</script>
